var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useSolana } from "@saberhq/use-solana";
import { useCallback } from "react";
import invariant from "tiny-invariant";
import { InsufficientSOLError, SolanaTransactionError, } from "./SolanaTransactionError";
export const useHandleTXsInternal = ({ refetch, onTxSend, onTxError, txRefetchDelayMs = 1000, waitForConfirmation = false, }) => {
    const { network } = useSolana();
    const handleTXs = useCallback((txs, message) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (txs.length === 0) {
            return {
                success: true,
                pending: [],
            };
        }
        try {
            const firstTX = txs[0];
            invariant(firstTX, "firstTX");
            const provider = firstTX.provider;
            // TODO(igm): when we support other accounts being the payer,
            // we need to alter this check
            const nativeBalance = (_a = (yield provider.connection.getAccountInfo(provider.wallet.publicKey))) === null || _a === void 0 ? void 0 : _a.lamports;
            if (!nativeBalance || nativeBalance === 0) {
                throw new InsufficientSOLError();
            }
            try {
                const pending = yield provider.sendAll(txs.map((tx) => ({ tx: tx.build(), signers: tx.signers })), {
                    preflightCommitment: "recent",
                    commitment: "recent",
                });
                // get the unique writable keys for every transaction
                const writable = [
                    ...new Set([...txs.flatMap((tx) => tx.writableKeys)]),
                ];
                // refetch everything
                // TODO(igm): this can fail
                // more importantly, this should be handled server-side
                // with our own websocket server
                void (() => __awaiter(void 0, void 0, void 0, function* () {
                    // await for the tx to be confirmed
                    yield Promise.all(pending.map((p) => p.wait()));
                    // then fetch
                    yield Promise.all(writable.map((wr) => __awaiter(void 0, void 0, void 0, function* () {
                        yield refetch(wr);
                        setTimeout(() => {
                            void refetch(wr);
                        }, txRefetchDelayMs);
                    })));
                }))();
                if (waitForConfirmation) {
                    // await for the tx to be confirmed
                    yield Promise.all(pending.map((p) => p.wait()));
                }
                onTxSend === null || onTxSend === void 0 ? void 0 : onTxSend({ network, pending, message });
                return {
                    success: true,
                    pending,
                };
            }
            catch (e) {
                // Log the instruction logs
                console.error("Transaction failed.", e);
                txs.forEach((tx, i) => {
                    if (txs.length > 1) {
                        console.debug(`TX #${i + 1} of ${txs.length}`);
                    }
                    console.debug(tx.debugStr);
                });
                throw e;
            }
        }
        catch (e) {
            onTxError === null || onTxError === void 0 ? void 0 : onTxError(new SolanaTransactionError(network, e, txs), message);
            return { success: false, pending: [] };
        }
    }), [
        network,
        onTxError,
        onTxSend,
        refetch,
        txRefetchDelayMs,
        waitForConfirmation,
    ]);
    const handleTX = useCallback((txEnv, message) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const { success, pending } = yield handleTXs([txEnv], message);
        return { success, pending: (_b = pending[0]) !== null && _b !== void 0 ? _b : null };
    }), [handleTXs]);
    return { handleTX, handleTXs };
};
//# sourceMappingURL=useHandleTXs.js.map